import axios from '@/plugins/axios';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';

export default {
	async fetchPaymentsOfThePlace({ commit }, id) {
		try {
			commit('setLoading', true);
			commit('setPayments', []);
			const { data } = await axios(`/payments/${id}`);
			commit('setPayments', data.payments);
		} catch (error) {
			commit('setPayments', []);
			snackBarError(error)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async savePayment({ commit }, payload) {
		try {
			commit('setLoadingSave', true);
			await axios(`/payments/create`, { method: 'post', data: payload });
			snackBarSuccess('Pago creado')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setLoadingSave', false);
		}
	},
	async editPayment({ commit }, { comments, id }) {
		try {
			await axios(`/payments/${id}`, {
				method: 'put',
				data: { comments },
			});
			snackBarSuccess('Pago actualizado')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteOnePayment({ commit }, id) {
		try {
			commit('setLoading', true);
			await axios(`/payments/${id}`, { method: 'delete' });
			commit('deletePayment', id);
			snackBarSuccess('Pago eliminado')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async generatePdfReport(store, placeId) {
		const { data } = await axios(`/payments/${placeId}/reports/pdf`, {
			method: 'get',
			responseType: 'arraybuffer',
		});
		return data;
	},
	async generateCsvReport(store, placeId) {
		const { data } = await axios(`/payments/${placeId}/reports/csv`, {
			method: 'get',
			responseType: 'arraybuffer',
		});
		return data;
	},
};
